import React from 'react';
import { classifyTrainType, trainTypeIcons, trainTypeColors, categoryLabels } from './trainUtils';

/**
 * Search hits in the right-hand panel. Picking one hands the selection to the map, which
 * jumps to the train's operating day and time if it is not currently running.
 */
const SearchResultsPanel = ({ results, loading, query, onSelect, onClose }) => (
  <aside className="kbs-drillin search-panel">
    <div className="kbs-drillin-header">
      <button className="kbs-drillin-close" onClick={onClose} title="Schließen">
        <i className="fa fa-arrow-left"></i>
      </button>
      <div className="kbs-drillin-headtext">
        <div className="kbs-drillin-title"><i className="fa fa-search"></i> Suche</div>
        <div className="kbs-drillin-date">
          {loading ? 'sucht…' : `${results.length} Treffer${query ? ` für „${query}"` : ''}`}
        </div>
      </div>
    </div>

    {loading && (
      <div className="kbs-drillin-loading"><i className="fa fa-spinner fa-spin"></i> lädt…</div>
    )}

    {!loading && results.length === 0 && (
      <p className="kbs-empty">Keine Züge gefunden. Anderer Betriebstag oder weniger Filter?</p>
    )}

    <ul className="search-results">
      {results.map((train, i) => {
        const type = classifyTrainType(train);
        const serie = train.trainSeries?.[0];
        return (
          <li
            key={train.UUID || train.trainUUID || i}
            className="search-result"
            style={{ borderLeftColor: trainTypeColors[type] }}
            onClick={() => onSelect(train)}
          >
            <span className="search-result-icon">{trainTypeIcons[type]}</span>
            <div className="search-result-body">
              <div className="search-result-name">
                {train.trainName_long || train.trainName || '?'}
                {train.trainLineName && <span className="search-result-line">{train.trainLineName}</span>}
              </div>
              <div className="search-result-meta">
                {train.operatingDate && <span><i className="fa fa-calendar"></i> {train.operatingDate}</span>}
                {train.trainTerminus && <span><i className="fa fa-map-marker"></i> {train.trainTerminus}</span>}
                {serie?.trainSerieNumber && <span><i className="fa fa-cog"></i> {serie.trainSerieNumber}</span>}
              </div>
            </div>
            <span className="search-result-cat">
              {categoryLabels[train.trainTypeProductCategorie] || ''}
            </span>
          </li>
        );
      })}
    </ul>
  </aside>
);

export default SearchResultsPanel;
